
import Vue from "vue";
import { Module } from "@/models/module";
export default Vue.extend({
	props: {
		module: {
			type: Object as () => Module
		}
	},
	computed: {
		mod():Module{
			return this.module;
		}
	}
});
